'use client';

import classNames from 'classnames';
import PageImage, { PageImageProps } from 'components/gruenland/organisms/image';
import { TasticProps } from 'frontastic/tastics/types';

const YggdrasilImageTastic = ({ data }: TasticProps<PageImageProps & { align: 'center' | 'left' | 'right' }>) => {
  return (
    <div
      className={classNames('flex', {
        'justify-center': data.align === 'center',
        'justify-left': data.align === 'left',
        'justify-right': data.align === 'right',
      })}
    >
      <PageImage image={data.image} />
    </div>
  );
};

export default YggdrasilImageTastic;
